import angular from 'angular';
import emailManagementModal from './emailManagementModal';

export default angular
  .module('components.emailManagementModal', [])
  .component('emailManagementModal', emailManagementModal).name;
